import { Download, FileText } from "lucide-react";
import { Button } from "@themes/pollinator/ui/Button";
import { Type } from "@themes/pollinator/ui/Type";
import { FileInfo } from "@platform/types/dashboard.types";

export type Props = {
  /** File information to display */
  file: FileInfo;
  /** Optional click handler for the download button */
  onClick?: () => void;
};

/**
 * A downloadable file asset component with file icon, metadata, and download button.
 */
export function DownloadableAssetFile({ file, onClick }: Props) {
  return (
    <div
      className="p-4 rounded-md border border-brand-800 flex flex-row items-center justify-between"
      data-testid="downloadable-asset-file"
    >
      <div className="flex items-center">
        <FileText
          className="mr-2 text-brand-600"
          size={20}
          data-testid="downloadable-asset-file-icon"
        />
        <div>
          <Type variant="h5" as="h3" className="text-brand-700">
            {file.name}
          </Type>
          <Type variant="caption" className="text-brand-700">
            {file.type}
            {file.size && ` · ${file.size}`}
            {file.date && ` · ${file.date}`}
          </Type>
        </div>
      </div>

      <Button
        as="a"
        href={file.downloadUrl}
        target="_blank"
        download
        title={`Download ${file.name}`}
        aria-label={`Download ${file.name}`}
        variant="secondary"
        iconComponent={Download}
        data-testid="downloadable-asset-file-download"
        onClick={onClick}
      >
        Download
      </Button>
    </div>
  );
}

export default DownloadableAssetFile;

